angular.module('LeasePilot').controller('ReportsPageController', [
  '$scope',
  '$window',
  '$location',
  '$sce',
  '$timeout',
  'ReportsUiService',
  function ReportsPageController($scope, $window, $location, $sce, $timeout, ReportsUiService) {
    var vm = this;

    vm.loading = false;
    vm.saving = false;
    vm.exportingCsv = false;
    vm.exportingXlsx = false;
    vm.errorMessage = '';
    vm.successMessage = '';
    vm.statusMessage = '';
    vm.showResults = false;
    vm.noResults = false;
    vm.rows = [];
    vm.columns = [];
    vm.currentColumnsMeta = null;
    vm.page = 1;
    vm.total = 0;
    vm.perPage = 50;
    vm.totalPages = 1;
    vm.sortBy = 'created_date';
    vm.sortDirection = 'desc';
    vm.sortLoadingColumnId = null;
    vm.sortLoadingColumnName = '';
    vm.selectedPage = '1';
    vm.saveModalOpen = false;
    vm.saveModalError = '';
    vm.saveReportName = '';
    vm.exportNotice = '';
    vm.toastVisible = false;
    vm.toastMessage = '';
    vm.toastType = 'info';
    vm.originalPrompt = '';
    vm.reportConfig = {};
    vm.activeColumns = '';
    vm.activeConditions = [];
    vm.filters = {};
    vm.explicitDatePreset = '';
    vm.currentSavedReport = null;
    vm.savedReportSignature = '';
    vm.lastAppliedSignature = '';
    vm.promptDropdownOpen = false;
    vm.promptDropdownItems = [];
    vm.promptHighlightedIndex = -1;
    vm.promptMentionStartPos = -1;
    vm.promptMentionCursorPos = -1;
    vm.operatorOptionsByType = {
      string: [
        { id: 'contains', name: 'contains' },
        { id: 'eq', name: 'equals' },
        { id: 'neq', name: 'does not equal' },
        { id: 'starts_with', name: 'starts with' },
        { id: 'ends_with', name: 'ends with' },
        { id: 'in', name: 'is one of' },
        { id: 'empty', name: 'is empty' },
        { id: 'not_empty', name: 'is not empty' }
      ],
      number: [
        { id: 'eq', name: '=' },
        { id: 'neq', name: '!=' },
        { id: 'gt', name: '>' },
        { id: 'gte', name: '>=' },
        { id: 'lt', name: '<' },
        { id: 'lte', name: '<=' },
        { id: 'empty', name: 'is empty' },
        { id: 'not_empty', name: 'is not empty' }
      ],
      date: [
        { id: 'eq', name: 'on' },
        { id: 'gt', name: 'after' },
        { id: 'gte', name: 'on or after' },
        { id: 'lt', name: 'before' },
        { id: 'lte', name: 'on or before' },
        { id: 'empty', name: 'is empty' },
        { id: 'not_empty', name: 'is not empty' }
      ],
      boolean: [
        { id: 'eq', name: 'is' },
        { id: 'neq', name: 'is not' },
        { id: 'empty', name: 'is empty' },
        { id: 'not_empty', name: 'is not empty' }
      ]
    };
    vm.columnOptions = [];
    // Cached lists for templates — ng-repeat over vm.someFn() breaks digest (new [] every tick).
    vm.filteredFormOptionsView = [];
    vm.groupedColumnOptionsView = [];
    vm.filteredUserOptionsView = [];
    vm.groupedFilteredUserOptionsView = [];
    vm.filteredBuildingOptionsView = [];
    vm.filterSummaryItemsView = [];
    vm.standardColumnsView = [];
    vm.pageOptionsView = [{ value: '1', label: 'Page 1' }];
    var REPORT_PENDING_STATE_STORAGE_PREFIX = 'leasepilot.reports.pendingState.';
    var REPORT_PAGE_STATE_STORAGE_PREFIX = 'leasepilot.reports.pageState.';
    var DEFAULT_SORT_BY = 'created_date';
    var DEFAULT_SORT_DIRECTION = 'desc';
    var DEFAULT_COLUMN_VALUE_TYPES = {
      tenant: 'string',
      asset: 'string',
      form_display_name: 'string',
      created_date: 'date',
      modified_date: 'date',
      created_by: 'string',
      active_drafting_time: 'number'
    };

    vm.init = function init() {
      var root = document.getElementById('report-page-root');
      if (!root) return;
      installUrlDebugLogging();
      vm.reportConfig = JSON.parse(root.getAttribute('data-config') || '{}');
      vm.standardColumnsView = Array.isArray(vm.reportConfig.default_columns)
        ? vm.reportConfig.default_columns
        : [];
      vm.filters = {
        date_from: null,
        date_to: null,
        building_ids: [],
        form_ids: [],
        document_types: [],
        created_by_user_ids: []
      };
      vm.wizard = {
        documentTypes: [],
        useSpecificForms: false,
        formIds: [],
        formSearch: '',
        columnMode: 'standard',
        additionalColumns: [],
        columnSearch: '',
        datePreset: 'ytd',
        dateFrom: null,
        dateTo: null,
        userIds: [],
        userSearch: '',
        buildingIds: [],
        buildingSearch: '',
        conditions: [],
        generatedPrompt: '',
        editedPrompt: '',
        parsingPrompt: false,
        promptParseResult: null,
        previewBefore: null,
        previewAfter: null,
        error: ''
      };
      vm.mentionData = { users: vm.reportConfig.users || [], buildings: vm.reportConfig.buildings || [] };
      refreshDocumentTypeOptions();
      syncWizardFromFilters();
      refreshDerivedFilterLists();
      loadWizardOptions();
      applyUrlParamsOrSavedReport();
    };

    vm.dateYearOptions = buildDateYearOptions(4);
    vm.dateQuarterOptions = buildDateQuarterOptions(6);
    vm.dateMonthOptions = buildDateMonthOptions(12);
    vm.selectedPreset = 'ytd';

    vm.applyPreset = function applyPresetClick(key) { applyPreset(key); };
    vm.setDatePreset = function setDatePreset(key) { applyPreset(key); };

    function installUrlDebugLogging() {
      if ($window.__reportsUrlDebugLoggingInstalled) return;
      $window.__reportsUrlDebugLoggingInstalled = true;

      function logUrlDebug(eventName, details) {
        console.groupCollapsed('[reports-url-debug] ' + eventName);
        console.log('href:', $window.location.href);
        if (details) console.log('details:', details);
        console.trace('stack');
        console.groupEnd();
      }

      $scope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
        logUrlDebug('$locationChangeStart', { newUrl: newUrl, oldUrl: oldUrl, event: event && event.name });
      });

      $scope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl) {
        logUrlDebug('$locationChangeSuccess', { newUrl: newUrl, oldUrl: oldUrl, event: event && event.name });
      });

      $window.__reportsLogUrlDebug = logUrlDebug;
    }

    function reportStateStorageSuffix(reportType) {
      return String(reportType || 'results');
    }

    function pendingReportStateStorageKey(reportType) {
      return REPORT_PENDING_STATE_STORAGE_PREFIX + reportStateStorageSuffix(reportType);
    }

    function persistedReportStateStorageKey(reportType) {
      return REPORT_PAGE_STATE_STORAGE_PREFIX + reportStateStorageSuffix(reportType);
    }

    function readSessionStorageJson(key) {
      try {
        if (!$window.sessionStorage || !key) return null;
        var raw = $window.sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function writeSessionStorageJson(key, value) {
      try {
        if (!$window.sessionStorage || !key) return;
        if (value == null) {
          $window.sessionStorage.removeItem(key);
          return;
        }
        $window.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }

    function removeSessionStorageItem(key) {
      try {
        if (!$window.sessionStorage || !key) return;
        $window.sessionStorage.removeItem(key);
      } catch (e) {}
    }

    function isPageReload() {
      if ($window.performance && $window.performance.getEntriesByType) {
        var navigationEntries = $window.performance.getEntriesByType('navigation') || [];
        if (navigationEntries.length > 0) {
          return navigationEntries[0].type === 'reload';
        }
      }
      if ($window.performance && $window.performance.navigation) {
        return $window.performance.navigation.type === 1;
      }
      return false;
    }

    function formatDateIso(d) {
      if (!d || Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) return '';
      var local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
      return local.toISOString().slice(0, 10);
    }

    function parseDateValue(value) {
      if (!value) return null;
      if (Object.prototype.toString.call(value) === '[object Date]') return value;
      if (typeof value !== 'string') return null;
      var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      var parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    function toDateParam(value) {
      if (!value) return '';
      if (Object.prototype.toString.call(value) === '[object Date]') return formatDateIso(value);
      if (typeof value === 'string') return value;
      return '';
    }

    function buildDateYearOptions(count) {
      var today = new Date();
      var years = [];
      for (var i = 0; i < count; i += 1) {
        var year = today.getFullYear() - i;
        years.push({ key: 'year_' + year, label: String(year) });
      }
      return years;
    }

    function buildDateQuarterOptions(count) {
      var today = new Date();
      var currentQuarter = Math.floor(today.getMonth() / 3) + 1;
      var currentYear = today.getFullYear();
      var options = [];
      for (var i = 0; i < count; i += 1) {
        var quarterIndex = currentQuarter - i;
        var yearShift = 0;
        while (quarterIndex <= 0) {
          quarterIndex += 4;
          yearShift += 1;
        }
        var year = currentYear - yearShift;
        options.push({
          key: 'quarter_' + year + '_q' + quarterIndex,
          label: 'Q' + quarterIndex + ' ' + year
        });
      }
      return options;
    }

    function buildDateMonthOptions(count) {
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var today = new Date();
      var options = [];
      for (var i = 0; i < count; i += 1) {
        var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        var keyMonth = String(d.getMonth() + 1);
        if (keyMonth.length < 2) keyMonth = '0' + keyMonth;
        options.push({
          key: 'month_' + d.getFullYear() + '_' + keyMonth,
          label: monthNames[d.getMonth()] + ' ' + d.getFullYear()
        });
      }
      return options;
    }

    function applyPreset(key) {
      if (vm.selectedPreset === key) {
        vm.selectedPreset = 'none';
        vm.explicitDatePreset = 'none';
        vm.wizard.datePreset = 'none';
        vm.wizard.dateFrom = null;
        vm.wizard.dateTo = null;
        syncFiltersFromWizard();
        return;
      }
      vm.selectedPreset = key;
      vm.explicitDatePreset = key;
      vm.wizard.datePreset = key;
      var today = new Date();
      var from = new Date(today.getTime());
      if (key === 'none') {
        vm.wizard.dateFrom = null;
        vm.wizard.dateTo = null;
        syncFiltersFromWizard();
        return;
      } else if (key === 'last_30_days') {
        from.setDate(today.getDate() - 30);
      } else if (key === 'last_90_days') {
        from.setDate(today.getDate() - 90);
      } else if (key === 'ytd') {
        from = new Date(today.getFullYear(), 0, 1);
      } else if (key === 'q1') {
        from = new Date(today.getFullYear(), 0, 1);
        today = new Date(today.getFullYear(), 2, 31);
      } else if (key === 'q2') {
        from = new Date(today.getFullYear(), 3, 1);
        today = new Date(today.getFullYear(), 5, 30);
      } else if (key === 'q3') {
        from = new Date(today.getFullYear(), 6, 1);
        today = new Date(today.getFullYear(), 8, 30);
      } else if (key === 'q4') {
        from = new Date(today.getFullYear(), 9, 1);
        today = new Date(today.getFullYear(), 11, 31);
      } else {
        var yearMatch = String(key).match(/^year_(\d{4})$/);
        if (yearMatch) {
          var year = Number(yearMatch[1]);
          from = new Date(year, 0, 1);
          today = new Date(year, 11, 31);
        } else {
          var quarterMatch = String(key).match(/^quarter_(\d{4})_q([1-4])$/);
          if (quarterMatch) {
            var quarterYear = Number(quarterMatch[1]);
            var quarter = Number(quarterMatch[2]);
            var quarterStartMonth = (quarter - 1) * 3;
            from = new Date(quarterYear, quarterStartMonth, 1);
            today = new Date(quarterYear, quarterStartMonth + 3, 0);
          } else {
            var monthMatch = String(key).match(/^month_(\d{4})_(\d{2})$/);
            if (monthMatch) {
              var monthYear = Number(monthMatch[1]);
              var month = Number(monthMatch[2]) - 1;
              from = new Date(monthYear, month, 1);
              today = new Date(monthYear, month + 1, 0);
            } else {
              return;
            }
          }
        }
      }
      vm.wizard.dateFrom = parseDateValue(formatDateIso(from));
      vm.wizard.dateTo = parseDateValue(formatDateIso(today));
      syncFiltersFromWizard();
    }

    vm.onDateInputChange = function onDateInputChange() {
      vm.selectedPreset = 'custom';
      vm.explicitDatePreset = 'custom';
      vm.wizard.datePreset = 'custom';
      syncFiltersFromWizard();
    };

    vm.clearFilters = function clearFilters() {
      applyPreset('ytd');
      vm.wizard.documentTypes = [];
      vm.wizard.useSpecificForms = false;
      vm.wizard.formIds = [];
      vm.wizard.columnMode = 'standard';
      vm.wizard.additionalColumns = [];
      vm.wizard.columnSearch = '';
      vm.wizard.userIds = [];
      vm.wizard.buildingIds = [];
      vm.wizard.conditions = [];
      vm.wizard.promptParseResult = null;
      vm.wizard.previewAfter = null;
      syncFiltersFromWizard();
      vm.activeColumns = '';
      vm.activeConditions = [];
      vm.currentColumnsMeta = null;
      vm.columns = vm.reportConfig.default_columns || [];
      vm.rows = [];
      vm.showResults = false;
      vm.noResults = false;
      vm.page = 1;
      vm.total = 0;
      vm.totalPages = 1;
      vm.selectedPage = '1';
      vm.pageOptionsView = [{ value: '1', label: 'Page 1' }];
      vm.statusMessage = '';
      vm.errorMessage = '';
      vm.successMessage = '';
      vm.exportNotice = '';
      vm.toastVisible = false;
      vm.toastMessage = '';
      applySortState(DEFAULT_SORT_BY, DEFAULT_SORT_DIRECTION);
    };

    vm.submit = function submit() {
      fetchReport(1, { resetResults: true });
    };

    vm.onPromptInput = function onPromptInput(event) {
      var target = (event && event.target) || document.getElementById('report-prompt-input') || document.activeElement;
      updatePromptMentionDropdown(target);
    };

    vm.onPromptKeydown = function onPromptKeydown(event) {
      if (!vm.promptDropdownOpen) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        vm.promptHighlightedIndex = Math.min(vm.promptDropdownItems.length - 1, vm.promptHighlightedIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        vm.promptHighlightedIndex = Math.max(0, vm.promptHighlightedIndex - 1);
      } else if ((event.key === 'Enter' || event.key === 'Tab') && vm.promptHighlightedIndex >= 0) {
        event.preventDefault();
        vm.selectPromptMention(vm.promptDropdownItems[vm.promptHighlightedIndex]);
      } else if (event.key === 'Escape') {
        closePromptMentionDropdown();
      }
    };

    vm.hidePromptMentionDropdown = function hidePromptMentionDropdown() {
      $timeout(function() {
        closePromptMentionDropdown();
      }, 120);
    };

    vm.selectPromptMention = function selectPromptMention(item) {
      if (!item) return;
      var input = document.getElementById('report-prompt-input');
      var text = vm.wizard.editedPrompt || '';
      var start = vm.promptMentionStartPos;
      var end = vm.promptMentionCursorPos;
      if (start < 0 || end < 0 || start > end) return;
      var insertion = '@' + item.name;
      vm.wizard.editedPrompt = text.substring(0, start) + insertion + ' ' + text.substring(end);
      closePromptMentionDropdown();
      $timeout(function() {
        if (!input) return;
        var nextPos = start + insertion.length + 1;
        input.focus();
        input.setSelectionRange(nextPos, nextPos);
      }, 0);
    };

    vm.hasPendingFilterChanges = function hasPendingFilterChanges() {
      return currentFilterSignature() !== vm.lastAppliedSignature;
    };

    vm.filterSummaryItems = function filterSummaryItems() {
      return vm.activeFilterItems();
    };

    vm.previousPage = function previousPage() {
      if (vm.page > 1) fetchReport(vm.page - 1);
    };

    vm.nextPage = function nextPage() {
      if (vm.page < vm.totalPages) fetchReport(vm.page + 1);
    };

    vm.jumpToPage = function jumpToPage(page) {
      var nextPage = Number(page);
      if (isNaN(nextPage) || nextPage < 1 || nextPage > vm.totalPages || nextPage === vm.page) return;
      fetchReport(nextPage);
    };

    vm.jumpToSelectedPage = function jumpToSelectedPage() {
      vm.jumpToPage(vm.selectedPage);
    };

    vm.toggleSort = function toggleSort(columnId, columnName) {
      if (!columnId || vm.loading) return;
      var nextDirection = defaultSortDirectionForColumn(columnId);
      if (vm.sortBy === columnId) {
        nextDirection = vm.sortDirection === 'desc' ? 'asc' : 'desc';
      }
      applySortState(columnId, nextDirection);
      fetchReport(1, {
        trigger: 'sort',
        sortColumnId: columnId,
        sortColumnName: columnName || columnId
      });
    };

    vm.isSortedBy = function isSortedBy(columnId, direction) {
      if (!columnId || vm.sortBy !== columnId) return false;
      return direction ? vm.sortDirection === direction : true;
    };

    vm.ariaSortForColumn = function ariaSortForColumn(columnId) {
      if (vm.sortBy !== columnId) return 'none';
      return vm.sortDirection === 'asc' ? 'ascending' : 'descending';
    };

    vm.sortButtonLabel = function sortButtonLabel(columnId, columnName) {
      var name = columnName || columnId || 'column';
      var nextDirectionLabel = defaultSortDirectionForColumn(columnId) === 'asc' ? 'ascending' : 'descending';
      if (vm.sortBy !== columnId) {
        return 'Sort by ' + name + ' ' + nextDirectionLabel + '.';
      }
      return 'Sorted by ' + name + ' ' + (vm.sortDirection === 'asc' ? 'ascending' : 'descending') + '. Click to sort ' + (vm.sortDirection === 'asc' ? 'descending.' : 'ascending.');
    };

    vm.isSortLoading = function isSortLoading(columnId) {
      return !!(vm.loading && vm.sortLoadingColumnId && vm.sortLoadingColumnId === columnId);
    };

    // -- Cached pill arrays (avoid new-object-per-digest causing infdig) --
    var _buildingPillsCache = { key: '', pills: [] };
    vm.selectedBuildingPills = function selectedBuildingPills() {
      var key = (vm.wizard.buildingIds || []).join(',');
      if (key === _buildingPillsCache.key) return _buildingPillsCache.pills;
      _buildingPillsCache.key = key;
      _buildingPillsCache.pills = !key ? [] : vm.wizard.buildingIds.map(function(id) {
        var building = (vm.reportConfig.buildings || []).find(function(b) { return String(b.id) === String(id); });
        return { id: id, name: building ? building.name : String(id) };
      });
      return _buildingPillsCache.pills;
    };

    vm.removeBuildingPill = function removeBuildingPill(id) {
      toggleInArray(vm.wizard.buildingIds, String(id));
      syncFiltersFromWizard();
    };

    vm.filteredBuildingOptions = function filteredBuildingOptions() {
      var q = (vm.wizard.buildingSearch || '').toLowerCase().trim();
      var list = vm.reportConfig.buildings || [];
      if (!q) return list;
      return list.filter(function(b) {
        var name = String(b.name || '').toLowerCase();
        return name.indexOf(q) >= 0 || String(b.id).indexOf(q) >= 0;
      });
    };

    var _userPillsCache = { key: '', pills: [] };
    vm.selectedUserPills = function selectedUserPills() {
      var key = (vm.wizard.userIds || []).join(',');
      if (key === _userPillsCache.key) return _userPillsCache.pills;
      _userPillsCache.key = key;
      _userPillsCache.pills = !key ? [] : vm.wizard.userIds.map(function(id) {
        return { id: id, name: resolveUserLabel(id) };
      });
      return _userPillsCache.pills;
    };

    vm.removeUserPill = function removeUserPill(id) {
      toggleInArray(vm.wizard.userIds, String(id));
      syncFiltersFromWizard();
    };

    vm.filteredUserOptions = function filteredUserOptions() {
      var q = (vm.wizard.userSearch || '').toLowerCase().trim();
      var list = vm.reportConfig.users || [];
      if (!q) return list;
      return list.filter(function(u) {
        var label = resolveUserLabel(u.id).toLowerCase();
        return label.indexOf(q) >= 0 || String(u.id).indexOf(q) >= 0;
      });
    };

    var _formPillsCache = { key: '', pills: [] };
    vm.selectedFormPills = function selectedFormPills() {
      var key = (vm.wizard.formIds || []).join(',');
      if (key === _formPillsCache.key) return _formPillsCache.pills;
      _formPillsCache.key = key;
      _formPillsCache.pills = !key ? [] : vm.wizard.formIds.map(function(id) {
        var form = (vm.reportConfig.forms || []).find(function(f) { return String(f.id) === String(id); });
        return { id: id, name: form ? (form.label || form.name || String(id)) : String(id) };
      });
      return _formPillsCache.pills;
    };

    vm.removeFormPill = function removeFormPill(id) {
      toggleInArray(vm.wizard.formIds, String(id));
      syncFiltersFromWizard();
    };

    vm.selectAllBuildings = function selectAllBuildings() {
      vm.wizard.buildingIds = (vm.reportConfig.buildings || []).map(function(b) { return String(b.id); });
      syncFiltersFromWizard();
    };

    vm.toggleBuilding = function toggleBuilding(id) {
      toggleInArray(vm.wizard.buildingIds, String(id));
      syncFiltersFromWizard();
    };

    vm.clearBuildings = function clearBuildings() {
      vm.wizard.buildingIds = [];
      syncFiltersFromWizard();
    };

    vm.selectAllBuildingsInMenu = function selectAllBuildingsInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.selectAllBuildings();
    };

    vm.clearBuildingsInMenu = function clearBuildingsInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.clearBuildings();
    };

    vm.selectAllUsers = function selectAllUsers() {
      vm.wizard.userIds = (vm.reportConfig.users || []).map(function(u) { return String(u.id); });
      syncFiltersFromWizard();
    };

    vm.isGroupFullySelected = function isGroupFullySelected(grp) {
      if (!grp || !grp.users || !grp.users.length) return false;
      var ids = vm.wizard.userIds || [];
      return grp.users.every(function(u) {
        return ids.indexOf(String(u.id)) >= 0;
      });
    };

    vm.toggleUsersInGroup = function toggleUsersInGroup(grp) {
      if (!grp || !grp.users || !grp.users.length) return;
      var ids = vm.wizard.userIds || [];
      var groupIds = grp.users.map(function(u) {
        return String(u.id);
      });
      var allSelected = groupIds.every(function(id) {
        return ids.indexOf(id) >= 0;
      });
      if (allSelected) {
        vm.wizard.userIds = ids.filter(function(id) {
          return groupIds.indexOf(id) < 0;
        });
      } else {
        var merged = ids.slice();
        groupIds.forEach(function(id) {
          if (merged.indexOf(id) < 0) merged.push(id);
        });
        vm.wizard.userIds = merged;
      }
      syncFiltersFromWizard();
    };

    vm.toggleUser = function toggleUser(id) {
      toggleInArray(vm.wizard.userIds, String(id));
      syncFiltersFromWizard();
    };

    vm.clearUsers = function clearUsers() {
      vm.wizard.userIds = [];
      syncFiltersFromWizard();
    };

    vm.selectAllUsersInMenu = function selectAllUsersInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.selectAllUsers();
    };

    vm.clearUsersInMenu = function clearUsersInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.clearUsers();
    };

    vm.selectAllForms = function selectAllForms() {
      vm.wizard.formIds = formsMatchingSelectedDocumentTypes().map(function(f) { return String(f.id); });
      syncFiltersFromWizard();
    };

    vm.toggleForm = function toggleForm(id) {
      toggleInArray(vm.wizard.formIds, String(id));
      syncFiltersFromWizard();
    };

    vm.filteredFormOptions = function filteredFormOptions() {
      var q = (vm.wizard.formSearch || '').toLowerCase().trim();
      var list = formsMatchingSelectedDocumentTypes();
      if (!q) return list;
      return list.filter(function(f) {
        var label = String(f.label || f.name || '').toLowerCase();
        return label.indexOf(q) >= 0 || String(f.id).indexOf(q) >= 0;
      });
    };

    vm.onColumnModeChange = function onColumnModeChange() {
      if (vm.wizard.columnMode === 'standard') {
        vm.wizard.additionalColumns = [];
      }
      syncFiltersFromWizard();
    };

    vm.toggleAdditionalColumn = function toggleAdditionalColumn(columnId) {
      if (!columnId) return;
      toggleInArray(vm.wizard.additionalColumns, String(columnId));
      syncFiltersFromWizard();
    };

    vm.hasAdditionalColumn = function hasAdditionalColumn(columnId) {
      return (vm.wizard.additionalColumns || []).indexOf(String(columnId)) >= 0;
    };

    var _columnPillsCache = { key: '', pills: [] };
    vm.selectedColumnPills = function selectedColumnPills() {
      var key = (vm.wizard.additionalColumns || []).join(',');
      if (key === _columnPillsCache.key) return _columnPillsCache.pills;
      _columnPillsCache.key = key;
      _columnPillsCache.pills = !key ? [] : vm.wizard.additionalColumns.map(function(id) {
        var col = (vm.columnOptions || []).find(function(c) { return String(c.id) === String(id); });
        return { id: id, name: col ? (col.name || String(id)) : String(id) };
      });
      return _columnPillsCache.pills;
    };

    vm.removeAdditionalColumn = function removeAdditionalColumn(columnId) {
      toggleInArray(vm.wizard.additionalColumns, String(columnId));
      syncFiltersFromWizard();
    };

    var _docTypePillsCache = { key: '', pills: [] };
    vm.selectedDocTypePills = function selectedDocTypePills() {
      var key = (vm.wizard.documentTypes || []).join(',');
      if (key === _docTypePillsCache.key) return _docTypePillsCache.pills;
      _docTypePillsCache.key = key;
      _docTypePillsCache.pills = !key ? [] : vm.wizard.documentTypes.map(function(id) {
        var dt = (vm.documentTypeOptions || []).find(function(d) { return String(d.id) === String(id); });
        return { id: id, name: dt ? (dt.name || String(id)) : String(id) };
      });
      return _docTypePillsCache.pills;
    };

    vm.removeDocumentType = function removeDocumentType(typeId) {
      var idx = vm.wizard.documentTypes.indexOf(typeId);
      if (idx >= 0) vm.wizard.documentTypes.splice(idx, 1);
      syncFiltersFromWizard();
    };

    vm.filteredColumnOptions = function filteredColumnOptions() {
      var query = (vm.wizard.columnSearch || '').toLowerCase().trim();
      if (!query) return vm.columnOptions || [];
      return (vm.columnOptions || []).filter(function(field) {
        return (field.name || '').toLowerCase().indexOf(query) >= 0 ||
          (field.id || '').toLowerCase().indexOf(query) >= 0 ||
          (field.category || '').toLowerCase().indexOf(query) >= 0;
      });
    };

    vm.groupedFilteredColumnOptions = function groupedFilteredColumnOptions() {
      var filtered = vm.filteredColumnOptions();
      var grouped = {};
      filtered.forEach(function(field) {
        var category = field.category || 'Other';
        if (!grouped[category]) grouped[category] = [];
        grouped[category].push(field);
      });
      return Object.keys(grouped).sort(function(a, b) { return a.localeCompare(b); }).map(function(category) {
        grouped[category].sort(function(a, b) { return (a.name || '').localeCompare(b.name || ''); });
        return { category: category, fields: grouped[category] };
      });
    };

    vm.documentTypeOptions = [];

    vm.toggleDocumentType = function toggleDocumentType(typeId) {
      toggleInArray(vm.wizard.documentTypes, String(typeId));
      pruneSelectedFormsByDocumentTypes();
      syncFiltersFromWizard();
    };
    vm.selectDocumentType = vm.toggleDocumentType;

    vm.isDocumentTypeSelected = function isDocumentTypeSelected(typeId) {
      return vm.wizard.documentTypes.indexOf(String(typeId)) >= 0;
    };
    vm.isDocTypeSelected = vm.isDocumentTypeSelected;

    vm.clearForms = function clearForms() {
      vm.wizard.formIds = [];
      syncFiltersFromWizard();
    };

    vm.addCondition = function addCondition() {
      vm.wizard.conditions.push({
        field_id: '',
        field_name: '',
        field_query: '',
        operator: 'eq',
        value: '',
        value_type: 'string',
        showFieldSuggestions: false
      });
    };

    vm.removeCondition = function removeCondition(index) {
      vm.wizard.conditions.splice(index, 1);
      syncFiltersFromWizard();
    };

    vm.filteredConditionFieldOptions = function filteredConditionFieldOptions(condition) {
      if (!condition) return vm.columnOptions.slice(0, 30);
      var query = (condition.field_query || '').toLowerCase().trim();
      if (!query) return vm.columnOptions.slice(0, 30);
      return vm.columnOptions.filter(function(field) {
        return (field.name || '').toLowerCase().indexOf(query) >= 0 ||
          (field.id || '').toLowerCase().indexOf(query) >= 0 ||
          (field.category || '').toLowerCase().indexOf(query) >= 0;
      }).slice(0, 30);
    };

    vm.selectConditionFieldSuggestion = function selectConditionFieldSuggestion(condition, field) {
      if (!condition || !field) return;
      condition.field_id = field.id;
      condition.field_name = field.name || field.id;
      condition.field_query = (field.name || field.id) + ' (' + field.id + ')';
      condition.value_type = field.value_type || 'string';
      condition.showFieldSuggestions = false;
      ensureValidOperatorForCondition(condition);
      syncFiltersFromWizard();
    };

    vm.showConditionFieldSuggestions = function showConditionFieldSuggestions(condition) {
      if (!condition) return;
      condition.showFieldSuggestions = true;
    };

    vm.hideConditionFieldSuggestions = function hideConditionFieldSuggestions(condition) {
      if (!condition) return;
      condition.showFieldSuggestions = false;
    };

    function buildConditionExampleRow(fieldId, fallbackName, operator, value, valueType) {
      var field = (vm.columnOptions || []).find(function(f) {
        return f.id === fieldId;
      });
      var name = field ? field.name || field.id : fallbackName;
      var vt =
        field && field.value_type ? field.value_type : valueType;
      return {
        field_id: fieldId,
        field_name: name,
        field_query: name + ' (' + fieldId + ')',
        operator: operator,
        value: String(value),
        value_type: vt,
        showFieldSuggestions: false
      };
    }

    function applyExampleConditionsFinish() {
      vm.wizard.conditions.forEach(function(c) {
        ensureValidOperatorForCondition(c);
      });
      refreshDerivedFilterLists();
      syncFiltersFromWizard();
    }

    /** FieldRegistry: baseRent, annualIncrease */
    vm.applyExampleConditionsDealTerms = function applyExampleConditionsDealTerms() {
      vm.wizard.conditions = [
        buildConditionExampleRow('baseRent', 'Base Rent', 'gt', '20', 'number'),
        buildConditionExampleRow('annualIncrease', 'Annual Increase (%)', 'gt', '3', 'number')
      ];
      applyExampleConditionsFinish();
    };

    /** FieldRegistry: premiseAreaSize, leaseYears */
    vm.applyExampleConditionsPremiseAndTerm =
      function applyExampleConditionsPremiseAndTerm() {
        vm.wizard.conditions = [
          buildConditionExampleRow(
            'premiseAreaSize',
            'Premise Area (SF)',
            'gt',
            '10000',
            'number'
          ),
          buildConditionExampleRow(
            'leaseYears',
            'Lease Term (Years)',
            'gte',
            '10',
            'number'
          )
        ];
        applyExampleConditionsFinish();
      };

    function groupUsersForFilterView(users) {
      users = users || [];
      if (users.length === 0) return [];
      var hasAnyGroup = false;
      for (var i = 0; i < users.length; i++) {
        var u = users[i];
        if (
          (u.group_key != null && u.group_key !== '') ||
          (u.groupKey != null && u.groupKey !== '')
        ) {
          hasAnyGroup = true;
          break;
        }
      }
      if (!hasAnyGroup) {
        return [
          { groupKey: '_all', groupLabel: 'Users', users: users.slice() }
        ];
      }
      var buckets = {};
      users.forEach(function(u) {
        var key =
          u.group_key != null && u.group_key !== ''
            ? String(u.group_key)
            : u.groupKey != null && u.groupKey !== ''
              ? String(u.groupKey)
              : '_other';
        var label = u.group_label || u.groupLabel || 'Users';
        if (!buckets[key]) {
          buckets[key] = { groupKey: key, groupLabel: label, users: [] };
        }
        buckets[key].users.push(u);
      });
      var keys = Object.keys(buckets);
      keys.sort(function(a, b) {
        if (a === 'company') return -1;
        if (b === 'company') return 1;
        return buckets[a].groupLabel.localeCompare(buckets[b].groupLabel);
      });
      return keys.map(function(k) {
        return buckets[k];
      });
    }

    function refreshDerivedFilterLists() {
      if (!vm.wizard) return;
      vm.filteredFormOptionsView = vm.filteredFormOptions();
      vm.groupedColumnOptionsView = vm.groupedFilteredColumnOptions();
      var filteredUsers = vm.filteredUserOptions();
      vm.filteredUserOptionsView = filteredUsers;
      vm.groupedFilteredUserOptionsView = groupUsersForFilterView(filteredUsers);
      vm.filteredBuildingOptionsView = vm.filteredBuildingOptions();
      vm.filterSummaryItemsView = vm.activeFilterItems();
      (vm.wizard.conditions || []).forEach(function(c) {
        c._conditionFieldOptionsView = vm.filteredConditionFieldOptions(c);
      });
    }

    function refreshPageOptions() {
      var totalPages = Math.max(1, Number(vm.totalPages) || 1);
      var options = [];
      for (var i = 1; i <= totalPages; i += 1) {
        options.push({ value: String(i), label: 'Page ' + i });
      }
      vm.pageOptionsView = options;
      vm.selectedPage = String(vm.page || 1);
    }

    $scope.$watch(
      function reportsFilterListDeps() {
        if (!vm.wizard) return '';
        return [
          vm.wizard.columnSearch,
          vm.wizard.formSearch,
          vm.wizard.userSearch,
          vm.wizard.buildingSearch,
          (vm.wizard.documentTypes || []).slice().sort().join(','),
          (vm.columnOptions || []).length,
          (vm.wizard.conditions || []).map(function(c) {
            return (c.field_query || '') + '\t' + (c.field_id || '') + '\t' + (c.operator || '') + '\t' + (c.value || '');
          }).join(';'),
          (vm.activeConditions || []).length
        ].join('\u0001');
      },
      function() {
        refreshDerivedFilterLists();
      }
    );

    $scope.$watch(
      function reportsFilterStateSignature() {
        if (!vm.wizard) return '';
        return JSON.stringify({
          documentTypes: (vm.wizard.documentTypes || []).slice().sort(),
          useSpecificForms: !!vm.wizard.useSpecificForms,
          formIds: (vm.wizard.formIds || []).slice().sort(),
          columnMode: vm.wizard.columnMode || 'standard',
          additionalColumns: (vm.wizard.additionalColumns || []).slice().sort(),
          datePreset: vm.wizard.datePreset || '',
          dateFrom: toDateParam(vm.wizard.dateFrom) || '',
          dateTo: toDateParam(vm.wizard.dateTo) || '',
          userIds: (vm.wizard.userIds || []).slice().sort(),
          buildingIds: (vm.wizard.buildingIds || []).slice().sort(),
          conditions: (vm.wizard.conditions || []).map(function(c) {
            return {
              field_id: c.field_id || '',
              field_name: c.field_name || '',
              operator: c.operator || '',
              value: c.operator === 'empty' || c.operator === 'not_empty' ? null : (c.value == null ? '' : c.value),
              value_type: c.value_type || ''
            };
          }),
          editedPrompt: (vm.wizard.editedPrompt || '').trim(),
          sortBy: vm.sortBy || DEFAULT_SORT_BY,
          sortDirection: vm.sortDirection || DEFAULT_SORT_DIRECTION,
          page: Number(vm.page || 1),
          showResults: !!vm.showResults,
          lastAppliedSignature: vm.lastAppliedSignature || '',
          currentSavedReportId: vm.currentSavedReport && vm.currentSavedReport.id ? String(vm.currentSavedReport.id) : '',
          savedReportSignature: vm.savedReportSignature || ''
        });
      },
      function(nextValue, previousValue) {
        if (!nextValue || nextValue === previousValue) return;
        syncFiltersFromWizard();
        syncUrlFromCurrentState({
          includeAutoRun: vm.showResults && currentFilterSignature() === vm.lastAppliedSignature,
          page: vm.page
        });
        persistCurrentPageState({
          includeAutoRun: vm.showResults && currentFilterSignature() === vm.lastAppliedSignature,
          page: vm.page
        });
      }
    );

    vm.operatorOptionsForCondition = function operatorOptionsForCondition(condition) {
      var typeKey = (condition && condition.value_type) ? String(condition.value_type).toLowerCase() : 'string';
      return vm.operatorOptionsByType[typeKey] || vm.operatorOptionsByType.string;
    };

    vm.conditionValueIsBoolean = function conditionValueIsBoolean(condition) {
      return condition && String(condition.value_type || '').toLowerCase() === 'boolean';
    };

    vm.conditionValueDisabled = function conditionValueDisabled(condition) {
      return condition && (condition.operator === 'empty' || condition.operator === 'not_empty');
    };

    vm.parsePromptReview = function parsePromptReview() {
      var prompt = (vm.wizard.editedPrompt || '').trim();
      if (!prompt) return;
      vm.wizard.parsingPrompt = true;
      vm.wizard.error = '';
      ReportsUiService.parseQuery(prompt, [])
        .then(function(res) {
          vm.wizard.promptParseResult = res.data || {};
          vm.wizard.previewAfter = snapshotFromParsed(vm.wizard.promptParseResult);
        })
        .catch(function(err) {
          vm.wizard.error = err && err.data && err.data.errors ? err.data.errors.join(', ') : 'Could not parse prompt.';
        })
        .finally(function() {
          vm.wizard.parsingPrompt = false;
        });
    };

    vm.revertPromptChanges = function revertPromptChanges() {
      vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
      vm.wizard.promptParseResult = null;
      vm.wizard.previewAfter = null;
    };

    vm.promptDiffItems = function promptDiffItems() {
      if (!vm.wizard.previewBefore || !vm.wizard.previewAfter) return [];
      var diffs = [];
      ['document_types', 'date_from', 'date_to', 'user_ids', 'building_ids', 'form_ids', 'conditions', 'column_mode', 'additional_columns'].forEach(function(key) {
        var before = normalizeDiffValue(vm.wizard.previewBefore[key]);
        var after = normalizeDiffValue(vm.wizard.previewAfter[key]);
        if (before !== after) diffs.push({ key: key, before: before || '(none)', after: after || '(none)' });
      });
      return diffs;
    };

    vm.applyPromptReview = function applyPromptReview() {
      if (!vm.wizard.promptParseResult) return;
      var snapshot = mergeSnapshotWithParsed(snapshotFromWizard(), vm.wizard.promptParseResult);
      vm.wizard.documentTypes = snapshot.document_types.slice();
      vm.wizard.dateFrom = parseDateValue(snapshot.date_from);
      vm.wizard.dateTo = parseDateValue(snapshot.date_to);
      vm.wizard.userIds = snapshot.user_ids.slice();
      vm.wizard.buildingIds = snapshot.building_ids.slice();
      vm.wizard.useSpecificForms = snapshot.form_ids.length > 0;
      vm.wizard.formIds = snapshot.form_ids.slice();
      vm.wizard.conditions = snapshot.conditions.slice();
      syncFiltersFromWizard();
    };

    vm.selectAllFormsInMenu = function selectAllFormsInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.selectAllForms();
    };

    vm.clearFormsInMenu = function clearFormsInMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      vm.clearForms();
    };

    vm.onToolbarSaveClick = function onToolbarSaveClick() {
      if (vm.currentSavedReport && vm.currentSavedReport.id) {
        vm.updateSavedReportInPlace();
      } else {
        vm.openSaveModal();
      }
    };

    vm.openSaveModal = function openSaveModal() {
      vm.saveReportName = '';
      vm.saveModalError = '';
      vm.saveModalOpen = true;
      focusInputById('save-report-name-input');
    };

    vm.closeSaveModal = function closeSaveModal() {
      vm.saveModalOpen = false;
      vm.saveModalError = '';
    };

    vm.updateSavedReportInPlace = function updateSavedReportInPlace() {
      if (!vm.currentSavedReport || !vm.currentSavedReport.id) return;
      vm.saving = true;
      vm.errorMessage = '';
      vm.successMessage = '';

      var filtersForSave = getFiltersForSave();
      if (vm.activeConditions && vm.activeConditions.length > 0) {
        filtersForSave.conditions = vm.activeConditions;
      }

      var payload = { filters: filtersForSave };
      if (vm.activeColumns) {
        payload.columns = vm.activeColumns.split(',').map(function(id) { return id.trim(); });
      }

      ReportsUiService.updateSavedReport(vm.currentSavedReport.id, payload)
        .then(function(res) {
          var updated = (res.data && res.data.saved_report) || null;
          if (updated) vm.currentSavedReport = updated;
          vm.savedReportSignature = currentFilterSignature();
          showToast('Saved report updated.', 'success');
        })
        .catch(function(err) {
          vm.errorMessage = getErrorMessage(err, 'Could not update saved report. Please try again.');
        })
        .finally(function() {
          vm.saving = false;
        });
    };

    vm.saveReport = function saveReport() {
      if (!vm.saveReportName || !vm.saveReportName.trim()) {
        vm.saveModalError = 'Please enter a report name.';
        focusInputById('save-report-name-input');
        return;
      }
      vm.saving = true;
      vm.errorMessage = '';
      vm.successMessage = '';
      vm.saveModalError = '';

      var filtersForSave = getFiltersForSave();
      if (vm.activeConditions && vm.activeConditions.length > 0) {
        filtersForSave.conditions = vm.activeConditions;
      }

      var saveBody = {
        name: vm.saveReportName.trim(),
        report_type: vm.reportConfig.report_type,
        filters: filtersForSave
      };
      if (vm.activeColumns) {
        saveBody.columns = vm.activeColumns.split(',').map(function(id) { return id.trim(); });
      }

      ReportsUiService.createSavedReport(saveBody)
        .then(function(res) {
          var sr = res.data && res.data.saved_report;
          if (sr && sr.id) {
            vm.currentSavedReport = sr;
            vm.savedReportSignature = currentFilterSignature();
          }
          showToast(
            'Report saved. You are viewing this saved report — use Update saved report to change it.',
            'success'
          );
          vm.saveModalError = '';
          vm.saveModalOpen = false;
        })
        .catch(function(err) {
          vm.saveModalError = getErrorMessage(err, 'Could not save report. Please try again.');
        })
        .finally(function() {
          vm.saving = false;
        });
    };

    vm.downloadExport = function downloadExport(format) {
      vm.exportNotice = '';
      vm.errorMessage = '';
      if (!vm.showResults || vm.noResults || !vm.total) {
        vm.errorMessage = 'No results to export.';
        return;
      }

      var payload = getReportPayload();
      payload.export_format = format;
      vm.statusMessage = 'Preparing ' + format.toUpperCase() + ' export.';
      if (format === 'csv') vm.exportingCsv = true;
      if (format === 'xlsx') vm.exportingXlsx = true;

      ReportsUiService.exportReport(payload, format)
        .then(function(res) {
          var blob = new Blob([res.data], { type: res.headers('content-type') || 'application/octet-stream' });
          var url = $window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = (vm.reportConfig.report_type || 'report') + '_' + new Date().toISOString().slice(0, 10) + '.' + format;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          $window.URL.revokeObjectURL(url);

          if (res.headers('x-export-truncated') === 'true') {
            var totalHdr = res.headers('x-export-total');
            vm.exportNotice =
              'Export limited to 10,000 rows.' +
              (totalHdr ? ' Your report has ' + totalHdr + ' results; only the first 10,000 are in the file.' : '');
            showToast(vm.exportNotice, 'info', 5000);
          }
          vm.statusMessage = 'Export is ready.';
          if (!vm.exportNotice) showToast('Your ' + format.toUpperCase() + ' export is ready.', 'success');
        })
        .catch(function(err) {
          vm.errorMessage = getErrorMessage(err, 'Export failed. Please try again.');
        })
        .finally(function() {
          vm.exportingCsv = false;
          vm.exportingXlsx = false;
        });
    };

    vm.hasActiveFilters = function hasActiveFilters() {
      return vm.activeFilterItems().length > 0;
    };

    vm.activeFilterItems = function activeFilterItems() {
      var items = [];
      if (vm.filters.date_from || vm.filters.date_to) {
        items.push('Date: ' + (toDateParam(vm.filters.date_from) || '...') + ' to ' + (toDateParam(vm.filters.date_to) || '...'));
      }
      if (vm.filters.building_ids && vm.filters.building_ids.length > 0) {
        var buildingLabels = vm.filters.building_ids.map(function(id) {
          var building = (vm.reportConfig.buildings || []).find(function(b) { return String(b.id) === String(id); });
          return building ? building.name : String(id);
        });
        items.push('Asset: ' + buildingLabels.join(', '));
      } else {
        items.push('Asset: All');
      }
      if (vm.wizard.documentTypes && vm.wizard.documentTypes.length > 0) items.push('Document Type: ' + vm.wizard.documentTypes.join(', '));
      else items.push('Document Type: All');
      if (vm.wizard.useSpecificForms && vm.wizard.formIds && vm.wizard.formIds.length > 0) {
        var formLabels = vm.wizard.formIds.map(function(id) {
          var form = (vm.reportConfig.forms || []).find(function(f) { return String(f.id) === String(id); });
          return form ? (form.label || form.name || String(id)) : String(id);
        });
        items.push('Forms: ' + formLabels.join(', '));
      } else {
        items.push('Forms: All');
      }
      if (vm.wizard.userIds && vm.wizard.userIds.length > 0) {
        items.push('Created By: ' + vm.wizard.userIds.map(resolveUserLabel).join(', '));
      } else {
        items.push('Created By: All');
      }
      var selectedColumnIds = vm.activeColumns ? vm.activeColumns.split(',').map(function(id) { return id.trim(); }).filter(Boolean) : [];
      if (selectedColumnIds.length > 0) {
        items.push('Columns: ' + labelsFromIds(selectedColumnIds, vm.columnOptions).join(', '));
      } else if (vm.columns && vm.columns.length > 0 && vm.currentColumnsMeta) {
        items.push('Columns: ' + vm.columns.map(function(c) { return c.name; }).join(', '));
      }
      var conditions = (vm.activeConditions && vm.activeConditions.length > 0)
        ? vm.activeConditions
        : (vm.wizard.conditions || []).filter(function(c) { return c.field_id; });
      if (conditions.length > 0) {
        items.push('Conditions: ' + conditions.map(conditionText).join(', '));
      }
      return items;
    };

    function resolveUserLabel(userId) {
      var user = (vm.reportConfig.users || []).find(function(u) { return String(u.id) === String(userId); });
      if (!user) return String(userId);
      if (user.label) return user.label;
      if (user.name && user.email) return user.name + ' (' + user.email + ')';
      if (user.name) return user.name;
      if (user.email) return user.email;
      return String(userId);
    }

    // Do not call $sce.trustAsHtml from the template (ng-bind-html) — each digest returns a new
    // TrustedValueWrapper and triggers $rootScope:infdig. Precompute per cell when rows load.
    function buildDisplayHtml(row, col) {
      var value = row[col.id];
      if (value == null || value === '') return '';
      if ((col.id === 'tenant' || col.id === 'document' || col.id === 'amendment' || col.id === 'form_display_name') && row.lease_url) {
        return $sce.trustAsHtml('<a href="' + escapeHtml(row.lease_url) + '">' + escapeHtml(String(value)) + '</a>');
      }
      return $sce.trustAsHtml(escapeHtml(formatCellValue(value)));
    }

    function attachDisplayHtmlToRows(rows, columns) {
      (rows || []).forEach(function(row) {
        row._displayHtml = {};
        (columns || []).forEach(function(col) {
          row._displayHtml[col.id] = buildDisplayHtml(row, col);
        });
      });
    }

    function conditionText(c) {
      var op = c.operator || '=';
      if (op === 'gt') op = '>';
      else if (op === 'gte') op = '>=';
      else if (op === 'lt') op = '<';
      else if (op === 'lte') op = '<=';
      else if (op === 'eq') op = '=';
      return (c.field_name || c.field_id || 'Field') + ' ' + op + ' ' + c.value;
    }

    function escapeHtml(s) {
      var div = document.createElement('div');
      div.textContent = String(s);
      return div.innerHTML;
    }

    function formatCellValue(val) {
      if (typeof val === 'boolean') return val ? 'Yes' : 'No';
      if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val)) {
        var d = new Date(val);
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        }
      }
      return String(val);
    }

    function getErrorMessage(err, fallback) {
      if (err && err.data) {
        var d = err.data;
        if (d.errors) {
          if (Array.isArray(d.errors) && d.errors.join) return d.errors.join(' ');
          if (typeof d.errors === 'string') return d.errors;
        }
        if (typeof d === 'string' && d.trim()) return d;
      }
      if (err && err.message) return err.message;
      return fallback;
    }

    function buildReportPayloadFromCurrentState() {
      var payload = { report_type: vm.reportConfig.report_type };
      var generatedPrompt = buildPromptFromWizard();
      var editedPrompt = (vm.wizard.editedPrompt || '').trim();
      var promptChanged = editedPrompt && editedPrompt !== (generatedPrompt || '').trim();

      // Always send structured filters. /api/reports/generate and /export apply these via
      // ResultsReportService; they do not evaluate nl_query. An early return that only
      // sent nl_query caused export (and generate) to run with no filters.
      payload.date_from = toDateParam(vm.filters.date_from);
      payload.date_to = toDateParam(vm.filters.date_to);
      if (vm.filters.building_ids && vm.filters.building_ids.length > 0) payload.building_ids = vm.filters.building_ids;
      if (vm.filters.form_ids && vm.filters.form_ids.length > 0) payload.form_ids = vm.filters.form_ids;
      if (vm.filters.document_types && vm.filters.document_types.length > 0) payload.document_types = vm.filters.document_types;
      if (vm.filters.created_by_user_ids && vm.filters.created_by_user_ids.length > 0) payload.created_by_user_ids = vm.filters.created_by_user_ids;
      if (vm.activeColumns) payload.columns = vm.activeColumns;
      if (vm.activeConditions && vm.activeConditions.length > 0) payload.conditions = vm.activeConditions;
      payload.sort_by = vm.sortBy || DEFAULT_SORT_BY;
      payload.sort_direction = vm.sortDirection || DEFAULT_SORT_DIRECTION;

      if (promptChanged) {
        payload.nl_query = editedPrompt;
        payload.generated_prompt = generatedPrompt;
        payload.edited_prompt = editedPrompt;
        payload.prompt_source = 'user_edited';
        return payload;
      }

      if (generatedPrompt) payload.generated_prompt = generatedPrompt;
      if ((vm.wizard.editedPrompt || '').trim()) payload.edited_prompt = (vm.wizard.editedPrompt || '').trim();
      payload.prompt_source = 'wizard_generated';
      return payload;
    }

    function getReportPayload() {
      syncFiltersFromWizard();
      return buildReportPayloadFromCurrentState();
    }

    function getFiltersForSave() {
      var payload = getReportPayload();
      var searchParams = $location.search() || {};
      var filters = {
        date_from: payload.date_from,
        date_to: payload.date_to
      };
      if (payload.building_ids) filters.building_ids = payload.building_ids;
      if (payload.form_ids) filters.form_ids = payload.form_ids;
      if (payload.document_types) filters.document_types = payload.document_types;
      if (payload.created_by_user_ids) filters.created_by_user_ids = payload.created_by_user_ids;
      if (payload.conditions) filters.conditions = payload.conditions;
      if (payload.sort_by) filters.sort_by = payload.sort_by;
      if (payload.sort_direction) filters.sort_direction = payload.sort_direction;
      if (vm.originalPrompt && vm.originalPrompt.trim()) filters.edited_prompt = vm.originalPrompt.trim();
      var generatedPromptParam = searchParams.generated_prompt;
      if (generatedPromptParam) filters.generated_prompt = generatedPromptParam;
      var promptSourceParam = searchParams.prompt_source;
      if (promptSourceParam) filters.prompt_source = promptSourceParam;
      return filters;
    }

    function normalizeConditionsArray(value) {
      return (Array.isArray(value) ? value : []).map(function(condition) {
        return {
          field_id: condition.field_id || '',
          field_name: condition.field_name || '',
          field_query: condition.field_query || '',
          operator: condition.operator || 'eq',
          value:
            condition.operator === 'empty' || condition.operator === 'not_empty'
              ? null
              : condition.value,
          value_type: condition.value_type || 'string',
          showFieldSuggestions: false
        };
      }).filter(function(condition) {
        return condition.field_id;
      });
    }

    function buildPersistedReportState(options) {
      options = options || {};
      var generatedPrompt = (vm.wizard && vm.wizard.generatedPrompt) || '';
      var editedPrompt = ((vm.wizard && vm.wizard.editedPrompt) || '').trim();
      var promptChanged = editedPrompt && editedPrompt !== String(generatedPrompt || '').trim();

      return {
        report_type: vm.reportConfig.report_type,
        explicit_date_preset: vm.explicitDatePreset || '',
        filters: {
          date_from: toDateParam(vm.filters.date_from),
          date_to: toDateParam(vm.filters.date_to),
          building_ids: normalizeToStringArray(vm.filters.building_ids),
          form_ids: normalizeToStringArray(vm.filters.form_ids),
          document_types: normalizeToStringArray(vm.filters.document_types),
          created_by_user_ids: normalizeToStringArray(vm.filters.created_by_user_ids)
        },
        columns: vm.activeColumns
          ? vm.activeColumns.split(',').map(function(id) { return id.trim(); }).filter(Boolean)
          : [],
        conditions: normalizeConditionsArray(vm.activeConditions),
        original_prompt: vm.originalPrompt || '',
        generated_prompt: generatedPrompt,
        edited_prompt: editedPrompt,
        prompt_source: promptChanged ? 'user_edited' : 'wizard_generated',
        current_saved_report: vm.currentSavedReport || null,
        saved_report_signature: vm.savedReportSignature || '',
        last_applied_signature: vm.lastAppliedSignature || '',
        sort_by: vm.sortBy || DEFAULT_SORT_BY,
        sort_direction: vm.sortDirection || DEFAULT_SORT_DIRECTION,
        auto_run:
          options.includeAutoRun != null
            ? !!options.includeAutoRun
            : !!(vm.showResults && currentFilterSignature() === vm.lastAppliedSignature),
        page: Math.max(1, Number(options.page || vm.page || 1)),
        updated_at: new Date().toISOString()
      };
    }

    function persistCurrentPageState(options) {
      if (!vm.reportConfig.report_type) return;
      writeSessionStorageJson(
        persistedReportStateStorageKey(vm.reportConfig.report_type),
        buildPersistedReportState(options)
      );
    }

    function applyStoredReportState(state) {
      if (!state || state.report_type !== vm.reportConfig.report_type) return false;

      vm.explicitDatePreset = state.explicit_date_preset || '';
      vm.filters.date_from = parseDateValue(state.filters && state.filters.date_from);
      vm.filters.date_to = parseDateValue(state.filters && state.filters.date_to);
      vm.filters.building_ids = normalizeToStringArray(state.filters && state.filters.building_ids);
      vm.filters.form_ids = normalizeToStringArray(state.filters && state.filters.form_ids);
      vm.filters.document_types = normalizeToStringArray(state.filters && state.filters.document_types);
      vm.filters.created_by_user_ids = normalizeToStringArray(
        state.filters && state.filters.created_by_user_ids
      );
      vm.activeColumns = normalizeToStringArray(state.columns).join(',');
      vm.activeConditions = normalizeConditionsArray(state.conditions);
      vm.originalPrompt = state.original_prompt || state.edited_prompt || state.generated_prompt || '';
      vm.currentSavedReport = state.current_saved_report || null;
      vm.savedReportSignature = state.saved_report_signature || '';
      vm.lastAppliedSignature = state.last_applied_signature || '';
      applySortState(state.sort_by, state.sort_direction);

      syncWizardFromFilters();

      if (state.generated_prompt) vm.wizard.generatedPrompt = state.generated_prompt;
      if (state.edited_prompt) vm.wizard.editedPrompt = state.edited_prompt;
      vm.wizard.previewBefore = snapshotFromWizard();
      vm.selectedPreset = vm.wizard.datePreset;
      refreshDerivedFilterLists();
      return true;
    }

    function restorePendingReportState(initialPage) {
      var key = pendingReportStateStorageKey(vm.reportConfig.report_type);
      var state = readSessionStorageJson(key);
      if (!state) return false;

      removeSessionStorageItem(key);
      if (!applyStoredReportState(state)) return false;

      urlSyncEnabled = true;
      persistCurrentPageState({
        includeAutoRun: !!state.auto_run,
        page: state.page || initialPage
      });
      if (state.auto_run) fetchReport(state.page || initialPage);
      return true;
    }

    function restorePersistedPageState(initialPage, options) {
      options = options || {};
      var state = readSessionStorageJson(
        persistedReportStateStorageKey(vm.reportConfig.report_type)
      );
      if (!state) return false;

      if (
        options.expectedSavedReportId &&
        String(
          (state.current_saved_report && state.current_saved_report.id) || ''
        ) !== String(options.expectedSavedReportId)
      ) {
        return false;
      }

      if (!applyStoredReportState(state)) return false;

      urlSyncEnabled = true;
      persistCurrentPageState({
        includeAutoRun: !!state.auto_run,
        page: state.page || initialPage
      });
      if (state.auto_run) fetchReport(state.page || initialPage);
      return true;
    }

    function applySavedReportFilters(filters, columns, conditions) {
      if (!filters) return;
      vm.explicitDatePreset = '';
      vm.filters.date_from = parseDateValue(filters.date_from) || vm.filters.date_from;
      vm.filters.date_to = parseDateValue(filters.date_to) || vm.filters.date_to;
      vm.filters.building_ids = normalizeToStringArray(filters.building_ids || filters.building_id);
      vm.filters.form_ids = normalizeToStringArray(filters.form_ids || filters.form_id);
      vm.filters.document_types = normalizeToStringArray(filters.document_types || filters.document_type);
      vm.filters.created_by_user_ids = normalizeToStringArray(filters.created_by_user_ids || filters.created_by_user_id);
      if (filters.edited_prompt) vm.originalPrompt = filters.edited_prompt;
      else if (filters.generated_prompt) vm.originalPrompt = filters.generated_prompt;
      if (columns && columns.length > 0) {
        vm.activeColumns = columns.map(function(c) { return typeof c === 'object' ? c.id : c; }).join(',');
      }
      if (conditions && conditions.length > 0) {
        vm.activeConditions = conditions;
      }
      applySortState(filters.sort_by, filters.sort_direction);
      syncWizardFromFilters();
      refreshDerivedFilterLists();
    }

    var urlSyncEnabled = false;

    function normalizeUrlParams(params) {
      var normalized = {};
      Object.keys(params || {}).sort().forEach(function(key) {
        var value = params[key];
        if (value == null || value === '') return;
        normalized[key] = String(value);
      });
      return normalized;
    }

    function setLocationSearch(params) {
      var nextParams = normalizeUrlParams(params);
      var currentParams = normalizeUrlParams($location.search() || {});
      if ($window.__reportsLogUrlDebug) {
        $window.__reportsLogUrlDebug('setLocationSearch', {
          currentParams: currentParams,
          nextParams: nextParams
        });
      }
      if (JSON.stringify(currentParams) === JSON.stringify(nextParams)) return;
      $location.search(nextParams);
      $location.replace();
    }

    function currentStateMatchesSavedReport() {
      return !!(
        vm.currentSavedReport &&
        vm.currentSavedReport.id &&
        vm.savedReportSignature &&
        currentFilterSignature() === vm.savedReportSignature
      );
    }

    function syncUrlFromCurrentState(options) {
      if (!urlSyncEnabled || !vm.reportConfig.report_type) return;
      options = options || {};

      var params = {};
      var payload = buildReportPayloadFromCurrentState();
      var currentPage = Number(options.page || vm.page || 1);
      var preserveSavedReport = currentStateMatchesSavedReport();

      if ($window.__reportsLogUrlDebug) {
        $window.__reportsLogUrlDebug('syncUrlFromCurrentState', {
          options: options,
          preserveSavedReport: preserveSavedReport,
          currentPage: currentPage,
          payload: payload,
          explicitDatePreset: vm.explicitDatePreset,
          wizardDatePreset: vm.wizard && vm.wizard.datePreset,
          lastAppliedSignature: vm.lastAppliedSignature,
          currentFilterSignature: currentFilterSignature()
        });
      }

      params.report_type = payload.report_type;
      if (preserveSavedReport) {
        params.saved_report_id = String(vm.currentSavedReport.id);
        if (options.includeAutoRun) params.auto_run = '1';
        if (currentPage > 1) params.page = String(currentPage);
        setLocationSearch(params);
        return;
      }

      if (options.includeAutoRun) params.auto_run = '1';
      if (currentPage > 1) params.page = String(currentPage);
      if (payload.sort_by && (payload.sort_by !== DEFAULT_SORT_BY || payload.sort_direction !== DEFAULT_SORT_DIRECTION)) {
        params.sort_by = payload.sort_by;
      }
      if (payload.sort_direction && (payload.sort_by !== DEFAULT_SORT_BY || payload.sort_direction !== DEFAULT_SORT_DIRECTION)) {
        params.sort_direction = payload.sort_direction;
      }

      setLocationSearch(params);
    }

    function applyUrlParamsOrSavedReport() {
      var params = $location.search() || {};
      var initialPage = Math.max(1, Number(params.page) || 1);
      if (params.nl_query) vm.originalPrompt = params.nl_query;
      if (!vm.originalPrompt && params.edited_prompt) vm.originalPrompt = params.edited_prompt;
      if (!vm.originalPrompt && params.generated_prompt) vm.originalPrompt = params.generated_prompt;
      if (params.columns) vm.activeColumns = params.columns;
      applySortState(params.sort_by, params.sort_direction);
      if (params.conditions) {
        try {
          vm.activeConditions = JSON.parse(params.conditions);
        } catch (e) {
          vm.activeConditions = [];
        }
      }

      var savedReportId = params.saved_report_id;
      if (savedReportId) {
        if (
          isPageReload() &&
          restorePersistedPageState(initialPage, {
            expectedSavedReportId: savedReportId
          })
        ) {
          return;
        }

        ReportsUiService.fetchSavedReport(savedReportId)
          .then(function(res) {
            var sr = res.data.saved_report;
            if (!sr || sr.report_type !== vm.reportConfig.report_type) {
              vm.errorMessage = 'This saved report is not a ' + vm.reportConfig.page_title + '.';
              return;
            }
            vm.currentSavedReport = sr;
            applySavedReportFilters(sr.filters, sr.columns, (sr.filters && sr.filters.conditions) || []);
            if (params.sort_by || params.sort_direction) applySortState(params.sort_by, params.sort_direction);
            vm.savedReportSignature = currentFilterSignature();
            fetchReport(initialPage);
          })
          .catch(function(err) {
            vm.errorMessage = getErrorMessage(err, 'Could not load saved report.');
          })
          .finally(function() {
            urlSyncEnabled = true;
          });
        return;
      }

      var hasPrefill = params.date_from || params.building_id || params.building_ids || params.form_id || params.form_ids || params.document_types || params.document_type || params.created_by_user_id || params.created_by_user_ids || params.columns || params.conditions || params.sort_by || params.sort_direction;
      if (hasPrefill) {
        var prefillDateFrom = params.date_from;
        var prefillDateTo = params.date_to;
        applySavedReportFilters({
          date_from: prefillDateFrom,
          date_to: prefillDateTo,
          building_ids: params.building_ids || params.building_id,
          form_ids: params.form_ids || params.form_id,
          document_types: params.document_types || params.document_type,
          created_by_user_ids: params.created_by_user_ids || params.created_by_user_id
        }, [], vm.activeConditions);
        if (prefillDateFrom || prefillDateTo) {
          vm.wizard.dateFrom = parseDateValue(prefillDateFrom);
          vm.wizard.dateTo = parseDateValue(prefillDateTo);
          var urlPreset = params.date_preset;
          vm.explicitDatePreset = urlPreset || 'custom';
          vm.wizard.datePreset = urlPreset || 'custom';
          vm.selectedPreset = urlPreset || 'custom';
          syncFiltersFromWizard();
        } else {
          vm.explicitDatePreset = vm.wizard.datePreset || 'custom';
          vm.selectedPreset = vm.wizard.datePreset || 'custom';
        }
        if (params.auto_run === '1') fetchReport(initialPage);
        urlSyncEnabled = true;
      } else {
        if (restorePendingReportState(initialPage)) return;
        if (isPageReload() && restorePersistedPageState(initialPage)) return;
        applyPreset('ytd');
        urlSyncEnabled = true;
      }
    }

    function toggleInArray(arr, val) {
      var idx = arr.indexOf(val);
      if (idx >= 0) arr.splice(idx, 1);
      else arr.push(val);
    }

    function formsMatchingSelectedDocumentTypes() {
      var forms = vm.reportConfig.forms || [];
      if (!vm.wizard || !vm.wizard.documentTypes || vm.wizard.documentTypes.length === 0) return forms;
      return forms.filter(function(form) {
        return vm.wizard.documentTypes.indexOf(form.document_type) >= 0;
      });
    }

    function selectedConcreteFormIds() {
      var selected = vm.wizard.formIds || [];
      var forms = vm.reportConfig.forms || [];
      var concrete = [];
      selected.forEach(function(id) {
        var form = forms.find(function(f) { return String(f.id) === String(id); });
        if (form && Array.isArray(form.form_ids) && form.form_ids.length > 0) {
          form.form_ids.forEach(function(fid) { concrete.push(String(fid)); });
        } else {
          concrete.push(String(id));
        }
      });
      return concrete.filter(Boolean).filter(function(v, idx, arr) { return arr.indexOf(v) === idx; });
    }

    function logicalFormIdsFromConcrete(concreteIds) {
      var concrete = (concreteIds || []).map(String);
      var forms = vm.reportConfig.forms || [];
      return forms.filter(function(form) {
        var mapped = (form.form_ids || []).map(String);
        if (mapped.some(function(fid) { return concrete.indexOf(fid) >= 0; })) return true;
        return concrete.indexOf(String(form.id)) >= 0;
      }).map(function(form) { return String(form.id); });
    }

    function pruneSelectedFormsByDocumentTypes() {
      var allowed = formsMatchingSelectedDocumentTypes().map(function(f) { return String(f.id); });
      vm.wizard.formIds = (vm.wizard.formIds || []).filter(function(id) { return allowed.indexOf(String(id)) >= 0; });
    }

    function syncFiltersFromWizard() {
      if (!vm.wizard) return;
      vm.filters.date_from = parseDateValue(vm.wizard.dateFrom);
      vm.filters.date_to = parseDateValue(vm.wizard.dateTo);
      vm.filters.building_ids = (vm.wizard.buildingIds || []).slice();
      vm.filters.form_ids = vm.wizard.useSpecificForms ? selectedConcreteFormIds() : [];
      vm.filters.document_types = (vm.wizard.documentTypes || []).slice();
      vm.filters.created_by_user_ids = (vm.wizard.userIds || []).slice();
      vm.activeColumns = vm.wizard.columnMode === 'additional' ? (vm.wizard.additionalColumns || []).join(',') : '';
      vm.activeConditions = (vm.wizard.conditions || []).filter(function(c) { return c.field_id; }).map(function(c) {
        return {
          field_id: c.field_id,
          field_name: c.field_name,
          operator: c.operator || 'eq',
          value: (c.operator === 'empty' || c.operator === 'not_empty') ? null : c.value,
          value_type: c.value_type || 'string'
        };
      });
      ensurePromptReviewState();
      refreshDerivedFilterLists();
    }

    function inferDatePresetFromFilters() {
      if (!vm.filters.date_from && !vm.filters.date_to) return 'none';
      if (vm.wizard.datePreset && vm.wizard.datePreset !== 'none' && vm.wizard.datePreset !== 'custom') return vm.wizard.datePreset;
      return 'custom';
    }

    /** Search input is bound to field_query; API/saved rows only have field_id + field_name. */
    function ensureConditionFieldQueryDisplay(c) {
      if (!c || !c.field_id) return;
      if ((c.field_query || '').trim()) return;
      var label = (c.field_name || c.field_id || '').trim();
      c.field_query = label + ' (' + c.field_id + ')';
    }

    function ensureConditionValueTypeFromColumn(c) {
      if (!c || !c.field_id || !vm.columnOptions || vm.columnOptions.length === 0) return;
      if (c.value_type != null && String(c.value_type).trim() !== '') return;
      var match = vm.columnOptions.find(function(f) { return f.id === c.field_id; });
      if (match && match.value_type) c.value_type = match.value_type;
    }

    function normalizeBooleanConditionValue(condition) {
      if (!condition) return;
      if (String(condition.value_type || '').toLowerCase() !== 'boolean') return;
      if (condition.operator === 'empty' || condition.operator === 'not_empty') return;
      var v = condition.value;
      if (v === true || v === 'true') condition.value = 'true';
      else if (v === false || v === 'false') condition.value = 'false';
      else condition.value = 'true';
    }

    function syncWizardFromFilters() {
      vm.wizard = vm.wizard || {};
      refreshDocumentTypeOptions();
      vm.wizard.documentTypes = (vm.filters.document_types || []).slice();
      vm.wizard.useSpecificForms = (vm.filters.form_ids || []).length > 0;
      vm.wizard.formIds = logicalFormIdsFromConcrete(vm.filters.form_ids || []);
      vm.wizard.formSearch = vm.wizard.formSearch || '';
      var activeColumnIds = vm.activeColumns ? vm.activeColumns.split(',').map(function(id) { return id.trim(); }).filter(Boolean) : [];
      vm.wizard.additionalColumns = activeColumnIds;
      vm.wizard.columnMode = activeColumnIds.length > 0 ? 'additional' : (vm.wizard.columnMode || 'standard');
      vm.wizard.columnSearch = vm.wizard.columnSearch || '';
      vm.wizard.dateFrom = parseDateValue(toDateParam(vm.filters.date_from));
      vm.wizard.dateTo = parseDateValue(toDateParam(vm.filters.date_to));
      vm.wizard.datePreset = vm.explicitDatePreset || inferDatePresetFromFilters();
      vm.wizard.userIds = (vm.filters.created_by_user_ids || []).slice();
      vm.wizard.userSearch = vm.wizard.userSearch || '';
      vm.wizard.buildingIds = (vm.filters.building_ids || []).slice();
      vm.wizard.buildingSearch = vm.wizard.buildingSearch || '';
      vm.wizard.conditions = (vm.activeConditions || []).slice();
      (vm.wizard.conditions || []).forEach(function(c) {
        ensureConditionFieldQueryDisplay(c);
        ensureConditionValueTypeFromColumn(c);
        ensureValidOperatorForCondition(c);
      });
      vm.wizard.generatedPrompt = vm.wizard.generatedPrompt || '';
      vm.wizard.editedPrompt = vm.wizard.editedPrompt || '';
      vm.wizard.parsingPrompt = false;
      vm.wizard.promptParseResult = vm.wizard.promptParseResult || null;
      vm.wizard.previewBefore = vm.wizard.previewBefore || null;
      vm.wizard.previewAfter = vm.wizard.previewAfter || null;
      vm.wizard.error = vm.wizard.error || '';
      vm.selectedPreset = vm.wizard.datePreset;
      vm.mentionData = vm.mentionData || {};
      vm.mentionData.users = vm.reportConfig.users || [];
      vm.mentionData.buildings = vm.reportConfig.buildings || [];
      ensurePromptReviewState();
    }

    function refreshDocumentTypeOptions() {
      var forms = vm.reportConfig.forms || [];
      var allowed = forms.map(function(f) { return f.document_type; }).filter(Boolean).filter(function(v, i, a) { return a.indexOf(v) === i; });
      var all = [
        { id: 'Lease', name: 'Lease' },
        { id: 'Amendment', name: 'Amendment' },
        { id: 'Loi', name: 'LOI' }
      ];
      if (!allowed.length) {
        vm.documentTypeOptions = all;
        return;
      }
      vm.documentTypeOptions = all.filter(function(opt) { return allowed.indexOf(opt.id) >= 0; });
    }

    function ensureValidOperatorForCondition(condition) {
      if (!condition) return;
      var allowed = vm.operatorOptionsForCondition(condition).map(function(op) { return op.id; });
      if (allowed.indexOf(condition.operator) === -1) {
        condition.operator = allowed[0] || 'eq';
      }
      normalizeBooleanConditionValue(condition);
    }

    function buildPromptFromWizard() {
      var pieces = ['Generate a report'];
      // Copy with .slice — Array(someArray) wraps in an extra array ([[]] or [[...]]) and breaks filters.
      var conditions = (vm.wizard.conditions || []).slice();
      if (conditions.length === 0 && Array.isArray(vm.activeConditions) && vm.activeConditions.length > 0) {
        conditions = vm.activeConditions.slice();
      }
      var selectedColumnIds = vm.activeColumns ? vm.activeColumns.split(',').map(function(id) { return id.trim(); }).filter(Boolean) : [];
      if (vm.wizard.documentTypes.length > 0) pieces.push('for ' + vm.wizard.documentTypes.join(' and '));
      if (vm.wizard.buildingIds.length > 0) pieces.push('for buildings ' + labelsFromIds(vm.wizard.buildingIds, vm.mentionData.buildings).join(', '));
      if (vm.wizard.userIds.length > 0) pieces.push('created by ' + labelsFromIds(vm.wizard.userIds, vm.mentionData.users).join(', '));
      if (vm.wizard.dateFrom && vm.wizard.dateTo) pieces.push('between ' + toDateParam(vm.wizard.dateFrom) + ' and ' + toDateParam(vm.wizard.dateTo));
      if (selectedColumnIds.length > 0) {
        pieces.push('with columns ' + labelsFromIds(selectedColumnIds, vm.columnOptions).join(', '));
      }
      if (conditions.length > 0) {
        var conditionClauses = conditions.filter(function(c) {
          var fieldLabel = c.field_name || c.field_id;
          if (!fieldLabel) return false;
          if (c.operator === 'empty' || c.operator === 'not_empty') return true;
          return String(c.value || '').trim();
        }).map(function(c) {
          var fieldLabel = c.field_name || c.field_id;
          if (c.operator === 'empty') return fieldLabel + ' is empty';
          if (c.operator === 'not_empty') return fieldLabel + ' is not empty';
          return fieldLabel + ' ' + (c.operator || 'eq') + ' ' + c.value;
        });
        if (conditionClauses.length > 0) {
          pieces.push('where ' + conditionClauses.join('; '));
        }
      }
      return pieces.join(' ') + '.';
    }

    function labelsFromIds(ids, options) {
      return ids.map(function(id) {
        var option = (options || []).find(function(item) { return String(item.id) === String(id); });
        return option ? (option.name || option.label || option.email || String(id)) : String(id);
      });
    }

    function normalizeDiffValue(value) {
      if (Array.isArray(value)) return value.join(', ');
      if (value == null) return '';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    }

    function snapshotFromWizard() {
      var conditions = (vm.wizard.conditions || []).slice();
      if (conditions.length === 0 && Array.isArray(vm.activeConditions) && vm.activeConditions.length > 0) {
        conditions = vm.activeConditions.slice();
      }
      return {
        document_types: vm.wizard.documentTypes.slice(),
        date_from: toDateParam(vm.wizard.dateFrom) || '',
        date_to: toDateParam(vm.wizard.dateTo) || '',
        user_ids: vm.wizard.userIds.slice(),
        building_ids: vm.wizard.buildingIds.slice(),
        form_ids: vm.wizard.useSpecificForms ? vm.wizard.formIds.slice() : [],
        conditions: conditions.filter(function(c) { return c && c.field_id; }),
        // Must track column picks so ensurePromptReviewState sees a change and resyncs editedPrompt;
        // otherwise editedPrompt stays stale, promptChanged stays true, and getReportPayload returns
        // nl_query-only (drops structured columns from the request).
        column_mode: vm.wizard.columnMode || 'standard',
        additional_columns: (vm.wizard.additionalColumns || []).map(String).slice().sort()
      };
    }

    function snapshotFromParsed(parsed) {
      var filters = (parsed && parsed.filters) || {};
      var conditions = (parsed && parsed.conditions) || [];
      return {
        document_types: normalizeToStringArray(filters.document_types || filters.document_type),
        date_from: filters.date_from || '',
        date_to: filters.date_to || '',
        user_ids: normalizeToStringArray(filters.created_by_user_ids || filters.created_by_user_id),
        building_ids: normalizeToStringArray(filters.building_ids || filters.building_id),
        form_ids: normalizeToStringArray(filters.form_ids || filters.form_id),
        conditions: conditions
      };
    }

    function mergeSnapshotWithParsed(base, parsed) {
      var p = snapshotFromParsed(parsed);
      return {
        document_types: p.document_types.length > 0 ? p.document_types : base.document_types,
        date_from: p.date_from || base.date_from,
        date_to: p.date_to || base.date_to,
        user_ids: p.user_ids.length > 0 ? p.user_ids : base.user_ids,
        building_ids: p.building_ids.length > 0 ? p.building_ids : base.building_ids,
        form_ids: p.form_ids.length > 0 ? p.form_ids : base.form_ids,
        conditions: p.conditions.length > 0 ? p.conditions : base.conditions
      };
    }

    function ensurePromptReviewState() {
      if (!vm.wizard) return;
      var nextSnapshot = snapshotFromWizard();
      var prevSnapshot = vm.wizard.previewBefore;
      var selectionsChanged = !prevSnapshot || JSON.stringify(prevSnapshot) !== JSON.stringify(nextSnapshot);
      vm.wizard.generatedPrompt = buildPromptFromWizard();
      if (selectionsChanged) {
        vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
        vm.wizard.promptParseResult = null;
        vm.wizard.previewAfter = null;
      } else if (!vm.wizard.editedPrompt || !vm.wizard.editedPrompt.trim()) {
        vm.wizard.editedPrompt = vm.wizard.generatedPrompt;
      }
      vm.wizard.previewBefore = nextSnapshot;
    }

    function updatePromptMentionDropdown(target) {
      var text = vm.wizard.editedPrompt || '';
      var cursor = target && typeof target.selectionStart === 'number' ? target.selectionStart : text.length;
      var before = text.substring(0, cursor);
      var match = before.match(/(?:^|\s)@([^\s@]*)$/);
      if (!match) {
        closePromptMentionDropdown();
        return;
      }
      var query = (match[1] || '').toLowerCase();
      vm.promptMentionStartPos = cursor - match[1].length - 1;
      vm.promptMentionCursorPos = cursor;
      vm.promptDropdownItems = buildPromptMentionItems(query);
      vm.promptDropdownOpen = vm.promptDropdownItems.length > 0;
      vm.promptHighlightedIndex = vm.promptDropdownOpen ? 0 : -1;
    }

    function buildPromptMentionItems(query) {
      var items = [];
      addPromptMentionItems(items, vm.mentionData.users, 'user', query);
      addPromptMentionItems(items, vm.mentionData.buildings, 'building', query);
      addPromptMentionItems(items, vm.columnOptions, 'field', query);
      return items.slice(0, 12);
    }

    function addPromptMentionItems(items, source, type, query) {
      (source || []).forEach(function(raw) {
        var name = String(raw.name || raw.label || raw.email || raw.id || '').trim();
        if (!name) return;
        var id = String(raw.id || name);
        if (query && name.toLowerCase().indexOf(query) < 0 && id.toLowerCase().indexOf(query) < 0) return;
        items.push({
          key: type + '-' + id,
          type: type,
          type_label: type.charAt(0).toUpperCase() + type.slice(1),
          id: id,
          name: name
        });
      });
    }

    function closePromptMentionDropdown() {
      vm.promptDropdownOpen = false;
      vm.promptDropdownItems = [];
      vm.promptHighlightedIndex = -1;
      vm.promptMentionStartPos = -1;
      vm.promptMentionCursorPos = -1;
    }

    function loadWizardOptions() {
      ReportsUiService.fetchMentions('', { fieldLimit: 1000 })
        .then(function(res) {
          var data = res.data || {};
          vm.mentionData.fields = data.fields || [];
          vm.columnOptions = (data.fields || []).map(function(field) {
            return {
              id: field.id,
              name: field.name || field.id,
              category: field.category || '',
              value_type: field.value_type || 'string'
            };
          });
          refreshDerivedFilterLists();
          syncWizardFromFilters();
        })
        .catch(function() {});
    }

    function defaultSortDirectionForColumn(columnId) {
      var valueType = getColumnValueType(columnId);
      return valueType === 'date' || valueType === 'number' ? 'desc' : 'asc';
    }

    function getColumnValueType(columnId) {
      if (!columnId) return 'string';
      if (DEFAULT_COLUMN_VALUE_TYPES[columnId]) return DEFAULT_COLUMN_VALUE_TYPES[columnId];
      var match = (vm.columnOptions || []).find(function(field) {
        return String(field.id) === String(columnId);
      });
      return match && match.value_type ? String(match.value_type) : 'string';
    }

    function applySortState(sortBy, sortDirection) {
      var normalizedSortBy = sortBy ? String(sortBy) : DEFAULT_SORT_BY;
      vm.sortBy = normalizedSortBy === 'document_type' ? 'form_display_name' : normalizedSortBy;
      if (sortDirection === 'asc' || sortDirection === 'desc') {
        vm.sortDirection = sortDirection;
      } else {
        vm.sortDirection = defaultSortDirectionForColumn(vm.sortBy);
      }
    }

    function normalizeToStringArray(value) {
      if (value == null || value === '') return [];
      if (Array.isArray(value)) {
        return value.map(function(v) { return String(v); }).filter(function(v) { return v !== ''; });
      }
      return String(value).split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v !== ''; });
    }

    function fetchReport(page, options) {
      options = options || {};
      if (options.resetResults) {
        vm.rows = [];
        vm.showResults = false;
        vm.noResults = false;
      }
      vm.sortLoadingColumnId = options.trigger === 'sort' ? options.sortColumnId || vm.sortBy : null;
      vm.sortLoadingColumnName = options.trigger === 'sort' ? options.sortColumnName || '' : '';
      vm.loading = true;
      vm.errorMessage = '';
      vm.successMessage = '';
      vm.statusMessage = options.trigger === 'sort'
        ? 'Sorting results by ' + (vm.sortLoadingColumnName || 'selected column') + '.'
        : 'Loading report results.';
      var payload = getReportPayload();
      payload.page = page || 1;
      payload.per_page = vm.perPage;

      ReportsUiService.generateReport(payload)
        .then(function(res) {
          var data = res.data || {};
          vm.rows = data.rows || [];
          vm.currentColumnsMeta = data.columns_meta && data.columns_meta.length > 0 ? data.columns_meta : null;
          vm.columns = vm.currentColumnsMeta || (vm.reportConfig.default_columns || []);
          attachDisplayHtmlToRows(vm.rows, vm.columns);
          vm.page = data.page || 1;
          vm.total = data.total != null ? data.total : vm.rows.length;
          vm.perPage = data.per_page || vm.perPage;
          vm.totalPages = vm.perPage > 0 ? Math.max(1, Math.ceil(vm.total / vm.perPage)) : 1;
          refreshPageOptions();
          vm.showResults = true;
          vm.noResults = vm.rows.length === 0;
          vm.statusMessage = vm.total + ' results loaded.';
          vm.lastAppliedSignature = currentFilterSignature();
          persistCurrentPageState({ includeAutoRun: true, page: vm.page });
        })
        .catch(function(err) {
          vm.showResults = false;
          vm.errorMessage = getErrorMessage(err, 'Network error. Please try again.');
        })
        .finally(function() {
          vm.loading = false;
          vm.sortLoadingColumnId = null;
          vm.sortLoadingColumnName = '';
        });
    }

    var toastTimeoutPromise = null;

    vm.dismissToast = function dismissToast() {
      vm.toastVisible = false;
      vm.toastMessage = '';
      if (toastTimeoutPromise) {
        $timeout.cancel(toastTimeoutPromise);
        toastTimeoutPromise = null;
      }
    };

    function showToast(message, type, duration) {
      if (!message) return;
      vm.toastMessage = message;
      vm.toastType = type || 'info';
      vm.toastVisible = true;
      if (toastTimeoutPromise) $timeout.cancel(toastTimeoutPromise);
      toastTimeoutPromise = $timeout(function() {
        vm.toastVisible = false;
        vm.toastMessage = '';
        toastTimeoutPromise = null;
      }, duration || 3500);
    }

    function focusInputById(id) {
      $timeout(function() {
        var input = document.getElementById(id);
        if (input) {
          input.focus();
          if (input.select) input.select();
        }
      }, 0);
    }

    function currentFilterSignature() {
      var wizardDocumentTypes = (vm.wizard && vm.wizard.documentTypes) ? vm.wizard.documentTypes.slice() : [];
      var wizardBuildingIds = (vm.wizard && vm.wizard.buildingIds) ? vm.wizard.buildingIds.slice() : [];
      var wizardUserIds = (vm.wizard && vm.wizard.userIds) ? vm.wizard.userIds.slice() : [];
      var wizardDateFrom = vm.wizard ? vm.wizard.dateFrom : null;
      var wizardDateTo = vm.wizard ? vm.wizard.dateTo : null;
      var wizardConditions = (vm.wizard && vm.wizard.conditions) ? vm.wizard.conditions : [];
      var wizardColumnMode = vm.wizard ? vm.wizard.columnMode : 'standard';
      var wizardAdditionalColumns = (vm.wizard && vm.wizard.additionalColumns) ? vm.wizard.additionalColumns.slice() : [];
      var formIdsForSignature = [];
      if (vm.wizard && vm.wizard.useSpecificForms) {
        formIdsForSignature = selectedConcreteFormIds();
      }
      var activeColumnsForSignature = wizardColumnMode === 'additional' ? wizardAdditionalColumns.join(',') : '';
      var activeConditionsForSignature = wizardConditions.filter(function(c) { return c && c.field_id; }).map(function(c) {
        return {
          field_id: c.field_id,
          field_name: c.field_name,
          operator: c.operator || 'eq',
          value: (c.operator === 'empty' || c.operator === 'not_empty') ? null : c.value,
          value_type: c.value_type || 'string'
        };
      });
      var normalized = {
        date_from: toDateParam(wizardDateFrom) || '',
        date_to: toDateParam(wizardDateTo) || '',
        building_ids: wizardBuildingIds.sort(),
        form_ids: formIdsForSignature.slice().sort(),
        document_types: wizardDocumentTypes.sort(),
        created_by_user_ids: wizardUserIds.sort(),
        columns: activeColumnsForSignature,
        conditions: activeConditionsForSignature,
        edited_prompt: (vm.wizard.editedPrompt || '').trim(),
        sort_by: vm.sortBy || DEFAULT_SORT_BY,
        sort_direction: vm.sortDirection || DEFAULT_SORT_DIRECTION
      };
      return JSON.stringify(normalized);
    }
  }
]);
